<template>
  <div class="result-list-container cs-scroll-style">
    <SpinnerContainer v-if="!uiResults && this.$store.state.appConfig.isLoading"/>
    <template v-else>
      <div v-if="uiResults">
        <div class="fit-container">
          <span>{{ $tI('Genetic Fit') }}: </span>
          <span :style="{ color: DistanceColor(uiResults.fit) }">{{ uiResults.fit }} ({{$tI(fitTitle(uiResults.fit))}})</span>
          <span @click="geneticFitInfoModal.showModal = true" class="open-info-modal-btn" 
            v-click-track="'Iframe.ancientDnaAncientOriginsBreakdownWhatIsGeneticFitClicked'">
            <InfoIcon />
          </span>
        </div>
        <div class="pop-view">
          <div v-for="itemAncestry in uiResults.resultList"
              :key="itemAncestry.resultName" 
              @click="onOpenDetailPage(itemAncestry)"
              class="pop-view-item" 
              v-click-track="'Iframe.ancientDnaAncientOriginsBreakdownPopulationClickFromLeftPanel'">
            <div class="d-flex">
              <b-media-aside class="mr-75">
                <b-avatar
                  rounded
                  size="55"
                  :src="itemAncestry.logoUrl"
                />
              </b-media-aside>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ itemAncestry.title }}
                </h6>
              </b-media-body>
            </div>
            <div class="d-flex align-items-center lab-p-8">
              <span class="mr-75 percent-txt"><b>{{ itemAncestry.resultValue.toFixed(1) }}%</b></span>
              <vue-apex-charts
                type="radialBar"
                height="40"
                width="40"
                :options="onGetChartOption(itemAncestry.color)"
                :series="[itemAncestry.resultValue.toFixed(1)]"
              />
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-center mt-4">
          <div class="d-flex align-items-center mt-1">
            <span class="lab-switch-desc">{{ $tI('Show all populations in this era') }}</span> 
            <label class="lab-switch">
              <input type="checkbox" 
                v-model="$store.state.periodicalResult.showAllEra" 
                v-click-track="'Iframe.ancientDnaAncientOriginsBreakdownShowAllPopulationsClicked'">
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div>
      <GeneticFitInfoModal v-if="geneticFitInfoModal.showModal" :modalObject="geneticFitInfoModal"/>
    </template>
  </div>
</template>

<script>
import { DistanceColor } from '@/services/Base/utils'
import VueApexCharts from 'vue-apexcharts'
import InfoIcon from '@/components/icons/InfoIcon.vue';
import GeneticFitInfoModal from '../modals/GeneticFitInfoModal.vue';

export default {
  components: {
    VueApexCharts,
    InfoIcon,
    GeneticFitInfoModal,
  },
  props: {
  },
  data() {
    return {
      geneticFitInfoModal: {
        showModal: false,
      },
    }
  },
  methods: {
    /* eslint-disable */
    onGetChartOption(color) {
      const barColor = color ? color : '#00ADB5';
      return {
        grid: {
          show: false,
          padding: {
            left: -15,
            right: -15,
            top: -12,
            bottom: -15,
          },
        },
        colors: [barColor],
        plotOptions: {
          radialBar: {
            hollow: {
              size: '22%',
            },
            track: {
              background: this.ddAlpha(color, 0.1),
            },
            dataLabels: {
              showOn: 'always',
              name: {
                show: false,
              },
              value: {
                show: false,
              },
            },
          },
        },
        stroke: {
          lineCap: 'round',
        },
      };
    },
    ddAlpha(color, opacity) {
      let _opacity = Math.round(Math.min(Math.max(opacity ?? 1, 0), 1) * 255);
      return color + _opacity.toString(16).toUpperCase();
    },
    fitTitle(value) {
      if(value <= 1) {
        return 'Very close';
      }
      if(value > 1 && value <= 3) {
        return 'Close';
      }
      if(value > 3 && value <= 5) {
        return 'Moderate';
      }
      return 'Distant';
    },
    DistanceColor,

    onOpenDetailPage(item) {
      this.$store.dispatch('periodicalResult/fetchSupervisedPeriodDetail', item.id);
      this.$store.state.periodicalResult.isOpenedPeriodicalDetail = true;
    },
  },
  computed: {
    uiResults() {
      return this.$store.getters['periodicalResult/getUiResults'];
    },
  },
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.result-list-container {
  padding: 28px;
}
</style>
